import { InboundTab } from './InboundTab';
import { OutboundTab } from './OutboundTab';
import { Tabs, Tab } from '../../components';

type TabsEnum = 'outbound' | 'inbound';

const SipTrunkPage = () => {
  return (
    <>
      <Tabs<TabsEnum>
        tabs={[
          { name: 'outbound', label: 'Outbound' },
          { name: 'inbound', label: 'Inbound' },
        ]}
        contentClassName="mt-md"
      >
        <Tab name="outbound">
          <OutboundTab />
        </Tab>
        <Tab name="inbound">
          <InboundTab />
        </Tab>
      </Tabs>
    </>
  );
};

export default SipTrunkPage;
